"use client";

import React from "react";
import Box from "../Box";
import styled from "styled-components";

type ProgressBarProps = {
  current: number;
  max: number;
  filledColor?: string;
  emptyColor?: string;
  fullColor?: string;
  height?: string;
};

// Styled container for the progress bar
const Container = styled(Box).attrs<{ height: string; emptyColor: string }>(() => {
  return {
    display: "flex",
    width: "100%",
    backgroundColor: "grayLight",
    borderRadius: "4px",
    overflow: "hidden",
  };
})<{ height: string; emptyColor: string }>``;

// Styled bar for the filled portion
const Filled = styled(Box).attrs<{ percentage: number; barColor: string }>(props => ({
  width: `${props.percentage}%`,
  backgroundColor: props.barColor,
  borderRadius: "4px",
  height: "100%",
  transition: "width 0.3s ease",
}))<{ percentage: number; barColor: string }>``;

const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  max,
  filledColor = "primary",
  emptyColor = "grayLight",
  fullColor = "primary",
  height = "8px",
}) => {
  const percentage = Math.min((current / max) * 100, 100); // Cap at 100%
  const barColor = percentage === 100 ? fullColor : filledColor;

  return (
    <Container height={height} emptyColor={emptyColor}>
      <Filled percentage={percentage} barColor={barColor} />
    </Container>
  );
};

export default ProgressBar;
